document.addEventListener("DOMContentLoaded", function() {

  if (!!document.querySelector("html .product__accordion .accordion__content img") === true){
    document.querySelector("html .product__accordion .accordion__content img").onclick = function(event) {
      var srcImage = event.currentTarget.getAttribute("src");
      var popup_img = '<div class="pop-up-img-size"><div><div class="product-media-modal__toggle"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></div><img src="'+ srcImage +'"/></div></div>';
      document.querySelector("#MainContent").insertAdjacentHTML("afterbegin", popup_img);

      document.querySelector(".pop-up-img-size").onclick = function(event) {
        if ( event.target.classList.contains("pop-up-img-size") === true ){
          document.querySelector(".pop-up-img-size").remove();
        }
      };
      document.querySelector(".pop-up-img-size .product-media-modal__toggle").onclick = function(event) {
        document.querySelector(".pop-up-img-size").remove();
      };
    };
  }


  /*var product_tags = document.querySelectorAll('.product__tags li');
  for (var i = 0; i < product_tags.length; i++) {
    product_tags[i].addEventListener('click', function(event) {
      document.querySelector('.product__accordion.accordion details').setAttribute("open","");
      document.querySelector('.product__accordion.accordion details summary').setAttribute("aria-expanded","true");
      
      var targetElement = document.querySelector('.product__accordion.accordion details');
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      var offsetPosition = elementPosition - 100;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  }*/
});


function adjustLabelPadding() {
  const fieldset = document.querySelector('.product-form__input--pill');
  if (!fieldset) return;
  
  const labels = fieldset.querySelectorAll('label');
  if (labels.length === 0) return;
  
  const existingStyle = document.getElementById('variant-label-padding');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  const tempStyle = document.createElement('style');
  tempStyle.id = 'variant-label-padding-temp';
  tempStyle.textContent = `@media screen and (max-width: 500px) {html .product-form__input--pill input[type=radio]+label{padding: 1rem 0;}}`;
  document.head.appendChild(tempStyle);
  
  fieldset.offsetHeight;
  
  let totalLabelWidth = 0;
  labels.forEach(label => {
    totalLabelWidth += label.offsetWidth;
  });
  
  tempStyle.remove();
  
  const totalGaps = (labels.length - 1) * 10;
  const totalContentWidth = totalLabelWidth + totalGaps;
  const fieldsetWidth = fieldset.offsetWidth;
  const difference = fieldsetWidth - totalContentWidth;
  const paddingPerLabel = (difference / labels.length) / 2;
  
  if (paddingPerLabel > 0) {
    const style = document.createElement('style');
    style.id = 'variant-label-padding';
    style.textContent = `@media screen and (max-width: 500px) {html .product-form__input--pill input[type=radio]+label{padding: 1rem ${paddingPerLabel}px;}}`;
    document.head.appendChild(style);
  }
}

adjustLabelPadding();

window.addEventListener('resize', adjustLabelPadding);